import { useRegisterActions as useKbarRegisterActions } from "kbar";
import type { Action } from "kbar";
import type { DependencyList } from "react";

const actionsSignature = (actions: Action[]) =>
	JSON.stringify(
		actions.map((action) => [
			action.id,
			action.name,
			action.subtitle ?? null,
			typeof action.section === "string" ? action.section : null,
			action.priority ?? null,
		]),
	);

/**
 * kbar resets the active index to the first row whenever the registered actions
 * change reference (KBarResults busts on `props.items`; see kbar's own TODO in
 * KBarResults). Callers here recompute `actions` on every background data
 * refetch, so keying registration on a content signature (not array identity)
 * keeps the user's selection stable while the visible action set is unchanged.
 */
export const useRegisterActions = (
	actions: Action[],
	dependencies?: DependencyList,
) => {
	useKbarRegisterActions(actions, dependencies ?? [actionsSignature(actions)]);
};
